import { Fragment } from 'react';
import { GiWaterSplash } from "react-icons/gi";

const BrandLogo = () => {
  return (
    <Fragment>
      <div className='flex-col py-2.5 px-4 mb-1'>
        <div className='flex justify-center'>
          <div className='relative'>
            {/* Ring Effect */}
            <div className='absolute inset-0 flex items-center justify-center overflow-hidden'>
              <div className='w-50 h-50 border-4 border-green-600 rounded-full' style={{ clipPath: 'polygon(0 0, 100% 0, 100% 50%, 0 50%)' }} />
            </div>
            {/* Logo */}
            <GiWaterSplash size={40} className='text-green-600 dark:text-green-500 mx-auto relative z-10' />
          </div>
        </div>
        <div className='flex items-center font-condensed align-middle text-center w-full'>
          <h2 className='text-center w-full font-public-sans -mt-1 text-green-600 dark:text-green-100 font-semibold text-[18.5px]'>H<sub className='text-[12px]'>2</sub>O</h2>

        </div>
      </div>
    </Fragment>
  )
}

export default BrandLogo